import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import React, { memo, useState } from 'react';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { useQuery } from 'react-query';

const ProductHistory = ({
  open,
  setOpen,
  itemData,
  setItemData,
  setRefetch,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const {
    data: dataList,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ['/admin/warehouses/historyshow', itemData?.id],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/admin/warehouses/historyshow/${itemData?.id}`
      );
      return response.data.data;
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
      // setBlocksError(true);
    },
    retry: false,
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[55vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !mb-5 !bg-[#CDCDCDC7]'
      >
        <span className='mr-4'>Mahsulot tarixi</span>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper'>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <div className='changes-table'>
                <TableContainer className='flex-auto w-full h-full !shadow-none !base-border'>
                  <Table
                    stickyHeader
                    sx={{ width: 'inherit' }}
                    aria-labelledby='tableTitle'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>№</TableCell>
                        <TableCell>Nomi</TableCell>
                        <TableCell>Soni</TableCell>
                        <TableCell>Narxi</TableCell>
                      </TableRow>
                    </TableHead>
                    {isLoading || isFetching ? (
                      <TableBody className='overflow-hidden' component='div'>
                        <TableRow component='div'>
                          <TableCell colSpan={6}>
                            <LinearProgress />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : dataList && dataList?.length > 0 ? (
                      <TableBody className='overflow-hidden'>
                        {dataList.map((row, rowIndex) => (
                          <TableRow hover tabIndex={-1} key={'row-' + rowIndex}>
                            <TableCell>{rowIndex + 1}</TableCell>
                            <TableCell>{row?.product?.name || ''}</TableCell>
                            <TableCell>{row?.amount || ''}</TableCell>
                            <TableCell>
                              <CurrencyFormat
                                value={Number(row?.price) || ''}
                                suffix={row?.isvalute === 1 ? ' USD' : ' UZS'}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow hover tabIndex={-1} key={'row-last-total'}>
                          <TableCell>#</TableCell>
                          <TableCell>
                            <b>Jami summa:</b>
                          </TableCell>
                          <TableCell />
                          <TableCell>
                              <b>
                                <div>
                                  <CurrencyFormat
                                    value={
                                      dataList
                                        ?.filter((b) => b?.isvalute === 0)
                                        .reduce((a, b) => a + Number(b?.amount) * Number(b?.price), 0)
                                    }
                                    suffix=" UZS"
                                  />
                                </div>
                                <div>
                                  <CurrencyFormat
                                    value={
                                      dataList
                                        ?.filter((b) => b?.isvalute === 1)
                                        .reduce((a, b) => a + Number(b?.amount) * Number(b?.price), 0)
                                    }
                                    suffix=" USD"
                                  />
                                </div>
                              </b>
                            </TableCell>
                          </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody component='div'>
                        <TableRow component='div'>
                          <TableCell colSpan={6}>
                            <span className='text-gray-400 flex items-center justify-center'>
                              <i className='bi bi-exclamation-octagon text-xl leading-4 mr-1' />{' '}
                              Ma'lumot topilmadi!
                            </span>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ProductHistory);
